import * as React from 'react';
import { ReactNode } from 'react';
import '../css/buttons.sass';

interface LinkButtonProps {
  name: string;
  id: string;
  children: ReactNode;
  style?: React.CSSProperties;
  focus?: boolean;
  theme?: 'night' | 'day';
  onClick?: Function;
  disabled?: boolean;
  smol?: boolean;
  type?: 'primary' | 'secondary';
  forward?: boolean;
  backward?: boolean;
  ariaLabel?: string | undefined;
  ariaCurrent?:
    | boolean
    | 'false'
    | 'true'
    | 'page'
    | 'step'
    | 'location'
    | 'date'
    | 'time';
}

export default function LinkButton(props: LinkButtonProps) {
  const { type = 'primary' } = props;
  let className = `${type}`;

  className = props.smol ? `${className} smol` : `${className} standard`;
  if (props.disabled) {
    className = `${className} disabled`;
  }
  if (props.theme && props.theme === 'night') {
    className = `${className} night`;
  }

  return (
    <button
      type="button"
      id={props.id}
      style={props.style}
      disabled={props.disabled}
      aria-disabled={props.disabled}
      aria-label={props.ariaLabel}
      aria-current={props.ariaCurrent}
      className={`link-button ${className}`}
      onMouseDown={e => {
        e.preventDefault();
      }}
      onClick={e => {
        if (props.onClick !== undefined && !props.disabled) {
          props.onClick(e);
        }
      }}
    >
      {props.backward && <img alt="" className="arrow-img backward" />}
      {props.children}
      {props.forward && <img alt="" className="arrow-img forward" />}
    </button>
  );
}
